import RichText from '@onclicks/sharedcomponents/RichText'
import { PreviewServiceBlock } from '@/payload-types'
import { Media } from '../../Media/Media'

type ItemFromProductService = NonNullable<PreviewServiceBlock['selectedPages']>[number]

export default function Card({ card }: { card: ItemFromProductService }) {
  const { backgroundImg, pageRichText } = card
  return (
    <figure className="relative flex h-full w-full flex-col rounded-2xl bg-primary p-6 hover:bg-secondary">
      <div className="relative">
        {backgroundImg && <Media resource={backgroundImg} />}
      </div>
      {pageRichText && (
        <div>
          <RichText
            data={pageRichText}
            className="font-bold"
            enableGutter={false}
            enableProse={false}
          />
        </div>
      )}
    </figure>
  )
}
